import React from "react";
import { Clock } from "lucide-react";

export default function CRMFollowUpsTab() {
  return (
    <ComingSoon
      testId="crm-followups-tab"
      title="Follow-Ups"
      lines={[
        "Auto follow-up rules (quote sent → 2d, abandoned booking → 24h, post-rental thank-you → 3d, birthdays)",
        "\"Follow-Ups Due Today\" queue with one-tap done / snooze / SMS blast",
        "Custom follow-up dates from any customer profile",
      ]}
    />
  );
}

function ComingSoon({ testId, title, lines }) {
  return (
    <div data-testid={testId} className="rounded-2xl border border-white/10 bg-black/25 p-8 text-center">
      <Clock size={22} className="mx-auto text-cyan mb-2" />
      <h3 className="font-serif text-2xl text-white">{title}</h3>
      <div className="label-caps text-[10px] text-amber-300 tracking-widest mt-2">Phase 2 · shipping next</div>
      <ul className="mt-4 text-white/60 text-sm space-y-1 max-w-lg mx-auto text-left inline-block">
        {lines.map((l, i) => <li key={i}>· {l}</li>)}
      </ul>
    </div>
  );
}
